import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import XHR from 'i18next-http-backend';

i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
      lng: 'pl',
      fallbackLng: 'pl',
      debug: true,
      react: {
        transSupportBasicHtmlNodes: true,
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      },
      interpolation: {
        escapeValue: false,
      },
      backend: {
        backends: [
          LocalStorageBackend,
          XHR
        ],
        backendOptions: [{
            prefix: 'i18next_res_',
            expirationTime: process.env.NODE_ENV === 'production' ? 7*24*60*60*1000 : 0,
            versions: { pl: process.env.REACT_APP_VERSION },
            store: window.localStorage
          }, {
          loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`
        }]
      }
    });


export default i18n;
